module.exports = __webpack_public_path__ + "img/japan-tuberculosis-female.ddc55fc4.png";